<template>
  <tab-content-layout title="ESTORNO">
    <b-row class="v-clean mb-3">
      <b-col>
        <b-row>
          <b-col>
            <nav class="container-fluid">
              <div class="nav nav-tabs row" id="nav-tab" role="tablist">
                <a
                  v-for="item in tabs"
                  :key="item.step"
                  @click="handleStep(item)"
                  :class="[
                    'nav-link link-menu col-md-3',
                    step == item.step && 'active',
                  ]"
                  data-toggle="tab"
                  role="tab"
                >
                  {{ item.title }}
                </a>
              </div>
            </nav>
            <hr />
            <div class="tab-content container-fluid">
              <div
                v-if="step == 'entry'"
                class="tab-pane fade show active"
                id="entry"
                role="tabpanel"
              >
                <Entry />
              </div>
              <div
                v-if="step == 'transfer'"
                class="tab-pane fade show active"
                id="transfer"
                role="tabpanel"
              >
                <Transfer />
              </div>
              <div
                v-if="step == 'output'"
                class="tab-pane fade show active"
                id="output"
                role="tabpanel"
              >
                <Output />
              </div>
              <div
                v-if="step == 'purchase'"
                class="tab-pane fade show active"
                id="purchase"
                role="tabpanel"
              >
                <Purchase />
              </div>
              <div
                v-if="step == 'purchasesell'"
                class="tab-pane fade show active"
                id="purchasesell"
                role="tabpanel"
              >
                <PurchaseSell />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" />
  </tab-content-layout>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import TabContentLayout from "../../Components/TabContentLayout";

import Entry from "./reversal/entry";
import Transfer from "./reversal/transfer";
import Output from "./reversal/output";
import Purchase from "./reversal/purchase";
import PurchaseSell from "./reversal/purchasesell";

export default {
  name: "Reversal",

  components: {
    TabContentLayout,
    ErrorsMessages,
    Entry,
    Transfer,
    Output,
    Purchase,
    PurchaseSell,
  },

  data() {
    return {
      errors: [],
      loading: false,
      step: "entry",

      tabs: [
        { title: "ENTRADA", step: "entry" },
        { title: "TRANSFERÊNCIA", step: "transfer" },
        { title: "SAÍDA", step: "output" },
        { title: "COMPRA", step: "purchase" },
        { title: "COMPRA / VENDA", step: "purchasesell" },
      ],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep({ step }) {
      let { menu, tipo, acao } = this.$router.currentRoute.query;

      if (step != acao) {
        this.$router.replace({ query: { menu, tipo, acao: step } });
      }

      this.step = step;
    },

    async retrieve() {
      let { menu, tipo, acao } = this.$router.currentRoute.query;

      if (!acao) {
        this.$router.replace({ query: { menu, tipo, acao: "entry" } });
        this.step = "entry";
      } else {
        this.step = acao;
      }
    },
  },
};
</script>

<style>
</style>